import Reflux from "reflux";

export const ActionsTempDraftCreation = Reflux.createActions({
  changeTempDraftCampaignId: {}
});
